var exports = {
  "Qs": "ThemeAcceptModal.module__content___alhISU",
  "h_": "ThemeAcceptModal.module__description___alhISU",
  "Hy": "ThemeAcceptModal.module__codeContainer___alhISU",
  "AS": "ThemeAcceptModal.module__pre___alhISU",
  "Y4": "ThemeAcceptModal.module__hljs___alhISU",
  "lB": "ThemeAcceptModal.module__codeActions___alhISU",
  "vo": "ThemeAcceptModal.module__codeActionsVisible___alhISU",
  "cL": "ThemeAcceptModal.module__copyButton___alhISU",
  "nJ": "ThemeAcceptModal.module__copyIcon___alhISU",
  "KQ": "ThemeAcceptModal.module__loadingText___alhISU",
  "kc": "ThemeAcceptModal.module__errorText___alhISU",
  "qr": "ThemeAcceptModal.module__footer___alhISU",
};

module.exports = exports;
